import { Directive, ElementRef, HostListener, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class DigitOnlyDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
        this.navigationKeys = [
            'Backspace',
            'Delete',
            'Tab',
            'Escape',
            'Enter',
            'Home',
            'End',
            'ArrowLeft',
            'ArrowRight',
            'Clear',
            'Copy',
            'Paste'
        ];
        this.inputElement = el.nativeElement;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyDown(e) {
        if (this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
            (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
            (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
            (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
            (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
            (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
            (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
            (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
            (e.key === 'x' && e.metaKey === true) // Allow: Cmd+X (Mac)
        ) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if (e.key === ' ' || isNaN(Number(e.key))) {
            e.preventDefault();
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onPaste(event) {
        event.preventDefault();
        /** @type {?} */
        const pastedInput = event.clipboardData
            .getData('text/plain')
            .replace(/\D/g, '');
        document.execCommand('insertText', false, pastedInput);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onDrop(event) {
        event.preventDefault();
        /** @type {?} */
        const textData = event.dataTransfer.getData('text').replace(/\D/g, '');
        this.inputElement.focus();
        document.execCommand('insertText', false, textData);
    }
}
DigitOnlyDirective.ɵfac = function DigitOnlyDirective_Factory(t) { return new (t || DigitOnlyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DigitOnlyDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DigitOnlyDirective, selectors: [["", "digitOnly", ""]], hostBindings: function DigitOnlyDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function DigitOnlyDirective_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); })("paste", function DigitOnlyDirective_paste_HostBindingHandler($event) { return ctx.onPaste($event); })("drop", function DigitOnlyDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); });
    } } });
/** @nocollapse */
DigitOnlyDirective.ctorParameters = () => [
    { type: ElementRef }
];
DigitOnlyDirective.propDecorators = {
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    onPaste: [{ type: HostListener, args: ['paste', ['$event'],] }],
    onDrop: [{ type: HostListener, args: ['drop', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DigitOnlyDirective, [{
        type: Directive,
        args: [{
                selector: '[digitOnly]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { 
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], 
    /**
     * @param {?} event
     * @return {?}
     */
    onPaste: [{
            type: HostListener,
            args: ['paste', ['$event']]
        }], 
    /**
     * @param {?} event
     * @return {?}
     */
    onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DigitOnlyModule {
}
DigitOnlyModule.ɵfac = function DigitOnlyModule_Factory(t) { return new (t || DigitOnlyModule)(); };
DigitOnlyModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DigitOnlyModule });
DigitOnlyModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DigitOnlyModule, { declarations: [DigitOnlyDirective], exports: [DigitOnlyDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DigitOnlyModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [DigitOnlyDirective],
                exports: [DigitOnlyDirective]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DigitOnlyDirective, DigitOnlyModule };

//# sourceMappingURL=uiowa-digit-only.js.map